import { use, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const DeleteEmployee = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [employeeName, setEmployeeName] = useState("");

    useEffect(() => {
        const fetchEmployee = async () => {
            try {
                const token = localStorage.getItem("token");

                const response = await axios.get(`https://jerinmjohn.pythonanywhere.com/api/employees/${id}/`, {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                });
                setEmployeeName(response.data.EmployeeName);
            } catch (error) {
                alert("Error fetching employee details");
                console.error(error);
            }
        };
        fetchEmployee(); // ✅ Called after definition
    }, [id]); // ✅ Now it's correct
    
    const handleDelete = async () => {
        try {
            const token = localStorage.getItem("token");
            await axios.delete(`https://jerinmjohn.pythonanywhere.com/api/employees/${id}/`, {
                headers: {
                    Authorization: `Token ${token}`,
                },
            });
            alert("Employee deleted successfully!");
            navigate("/dashboard");
        } catch (error) {
            alert("Error deleting employee");
            console.error(error);
        }

    };
    return (
        <div className="container mt-5">
            <div className="row justify-content-center">
                <div className="col-md-6">
                    <div className="card shadow p-4 text-center">
                        <h2 className="text-danger">Delete Employee</h2>
                        <p>Are you sure you want to delete<strong> {employeeName}?</strong></p>
                        <div className="d-flex justify-content-center mt-4">
                            <button type="button" className="btn btn-danger" onClick={handleDelete}>
                                Yes, Delete


                            </button>
                            <button type="button" className="btn btn-secondary" onClick={() => navigate("/dashboard")}>
                                Cancel
                            </button>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    )
}
export default DeleteEmployee;